(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/router.js');

(function(Backbone, _, svs) {
  'use strict';

  var $nav = $('.tt-navigation');
  var $filter = $('.tt-filter');

  svs.tt.Router = Backbone.Router.extend({
    routes: svs.core.data.routes,

    routeStart: function(product) {
      var productSetting = {};
      if (product) {
        productSetting = svs.tt.productSettings[product];
      } else {
        productSetting = svs.tt.productSettings[svs.tt.defaultProduct];
      }

      svs.tt.draws.newProductSelected(productSetting);
      svs.tt.filter.newProductSelected(productSetting);

      $nav.html(
        new svs.tt.views.TTNavigation({
          model: new Backbone.Model({
            productSettings: svs.tt.productSettings,
            activeProduct: product
          })
        }).render().el
      );
      $filter.html(
        new svs.tt.views.TTFilter({
          model: svs.tt.filter
        }).render().el
      );

      svs.tt.app.showView(
        new svs.tt.views.TTLayout({ productSetting: productSetting })
      );
    }
  });
})(Backbone, _, svs);


 })(window);